var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";
import Logo from "../../assets/icons/logo";
import sizes from "../../designSystem/sizes";
import useScreenSize from "../../hooks/useScreenSize";
import TextPreview from "../TextPreview/TextPreview";
var rotate = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    transform: rotateY(0deg);\n  }\n\n  to {\n    transform: rotateY(360deg);\n  }\n"], ["\n  from {\n    transform: rotateY(0deg);\n  }\n\n  to {\n    transform: rotateY(360deg);\n  }\n"])));
var RotatingLogo = styled(Logo)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 32px;\n  animation: ", " 2.5s linear infinite;\n\n  @media (max-width: ", "px) {\n    margin-right: unset;\n    margin-bottom: 32px;\n  }\n"], ["\n  margin-right: 32px;\n  animation: ", " 2.5s linear infinite;\n\n  @media (max-width: ", "px) {\n    margin-right: unset;\n    margin-bottom: 32px;\n  }\n"])), rotate, sizes.md);
var LogoContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 12px;\n  margin-left: -12px;\n"], ["\n  padding: 12px;\n  margin-left: -12px;\n"])));
var Container = styled.div.attrs({
    className: "d-flex align-items-center justify-content-center",
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0 100px;\n"], ["\n  padding: 0 100px;\n"])));
var Content = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100vw;\n  line-heihgt: 100px;\n  word-break: break-all; \n  word-wrap: break-word; \n  text-align: center;\n  padding: 0 30px;\n  margin-top: 20px;\n"], ["\n  width: 100vw;\n  line-heihgt: 100px;\n  word-break: break-all; \n  word-wrap: break-word; \n  text-align: center;\n  padding: 0 30px;\n  margin-top: 20px;\n"])));
var Geoblocked = function (_a) {
    var treeLogo = _a.treeLogo;
    var t = useTranslation().t;
    var width = useScreenSize().width;
    var isMobile = width < sizes.md;
    return (_jsx(Container, { children: _jsxs(TextPreview, __assign({ titleStyle: {
                width: '100vw',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            } }, { children: [treeLogo, _jsxs(Content, { children: [t("shared:GeoblockWarning:title"), " "] }, void 0)] }), void 0) }, void 0));
};
export default Geoblocked;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Geoblocked.js.map